import type { ListBatchJobItemsParams } from "../../../../../lib/corpusApi";

export type CoverageGapRecheckTabKey = "unanswered" | "answered" | "failed";

export interface CoverageGapRecheckTabConfig {
  label: string;
  /** Query params sent to GET /batch-jobs/:id/items for this tab. */
  apiFilters: Pick<ListBatchJobItemsParams, "status" | "outcome">;
}

/** One tab per outcome of the check, plus the claims it failed on. Order is display order. */
export const COVERAGE_GAP_RECHECK_TABS: Record<
  CoverageGapRecheckTabKey,
  CoverageGapRecheckTabConfig
> = {
  unanswered: { label: "Still unanswered", apiFilters: { outcome: "unanswered" } },
  answered: { label: "Now answered", apiFilters: { outcome: "answered" } },
  failed: { label: "Failed", apiFilters: { status: "failed" } },
};

export const COVERAGE_GAP_RECHECK_TAB_ORDER: CoverageGapRecheckTabKey[] = [
  "unanswered",
  "answered",
  "failed",
];
